export class SplitBillingDetails {
	SplitBillingId: number | null = 0;
	CustomerId: number | null = 0;
	SharePercentage: number | undefined;
	Amount: number | undefined;
	ShareAmount: number | undefined;
	SplitParty: string | undefined = '';
	CustomerName: string | null = '';
	CreatedDate: Date | undefined;
	ModifiedDate: Date | undefined;
	ServiceOrderId: number | undefined;
	ItemId: number | undefined;
	Modified: number | undefined;
}

export enum SplitPartyType {
	Warranty = 1000,
	Goodwill = 2000,
	Internal = 3000,
	Insurance = 4000,
	Corporate = 5000,
	Individual = 6000
}

export interface ISplitPartyInvoiceDetail {
	CustomerId?: number;
	CustomerName: string;
	SplitPartyTypeId: number;
	SplitPartyTypeName: string;
	IsBilled: boolean;
	BillingDate?: Date;
	IsSelected: boolean;
	OverAllLineItemCompletionStatus: boolean;
	IsCreditNote: boolean;
}
